module.exports = __webpack_public_path__ + "img/icon-twitter.b090cce5.svg";